<template>
  <div class="page">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'Mycards' | lang }}</div>
      <button @click="goTo('/cart', false, true)" :aria-label="dictValue('CartWithItems', {nitems: cartLength})">
        <i class="fa fa-fw fa-shopping-cart" :badge="cartLengthLabel"></i>
      </button>
    </header>
    <div v-if="loading"><div class="flexcentered bigger"><i class="fa fa-fw fa-refresh fa-spin"></i></div></div>
    <div v-else>
      <div v-if="tessereComputed && tessereComputed.length > 0">
        <ul class="results arrow">
          <li v-for="(c, idx) in tessereComputed" :key="idx" @click="next(c)" tabindex="0" @keypress.space="next(c)">
            <div class="title">{{ 'CSCnr' | lang }} {{c.MediaSerialNumber}}</div>
            <div class="subtitle" v-if="c.MediaTitleProduct">{{c.MediaTitleProduct}}</div>
            <div class="subtitle" v-if="c.humanExpirationDate">{{ 'ExpirationDate' | lang }} {{c.humanExpirationDate}}</div>
            <div class="subtitle" v-else>{{ 'ExpirationDateUnknown' | lang }}</div>
          </li>
        </ul>
      </div>
      <div v-else class="flexcentered bigger">
        {{ 'NoUserCsc' | lang }}
      </div>
    </div>
    <!-- <footer>
      <button @click="logout">{{ 'logout' | lang }}</button>
    </footer> -->
  </div>
</template>

<script>
import moment from 'moment'
import page from '@/mixins/routeControl'
import databaseWrapperMixin from '@/mixins/databaseWrapperMixin'
// import csc from '@/components/CSC.vue'

export default {
  name: 'CSCselectorPage',
  mixins: [ page, databaseWrapperMixin ],
  // components: { csc },
  data () {
    return {
      loading: false,
      allDetails: []
    }
  },
  computed: {
    tessereComputed () {
      if (this.userProfile && this.userProfile.tessere) {
        return this.userProfile.tessere.filter((t, index) => this.allDetails[index] && this.canBuyProductsOnMedia(this.allDetails[index]))
        .map(t => {
          let humanExpirationDate = t.ExpirationDate ? moment(t.ExpirationDate).format('DD/MM/YYYY') : null
          return { ...t, humanExpirationDate }
        })
      }
      return null
    }
  },
  methods: {
    next (csc) {
      this.buying = {
        csc
      }
      this.goTo('/products/csc/' + csc.MediaSerialNumber, false)
    },
    canBuyProductsOnMedia(mediaDetail)
    {
      return mediaDetail.IsFull!=true && 
      mediaDetail.IsLocked!=true && 
      mediaDetail.IsInvalid!=true && 
      mediaDetail.IsSalesUnavailable!=true && 
      mediaDetail.IsBlackListed!=true &&
      mediaDetail.IsExpired!=true
      
    }
    ,
 updateCSClist() { 
  this.loading = true; 
  this._getUserCSCList()
    .then(csclist => {
      const requests = csclist.map(cardData => {
        return this._getUserCSCDetails(cardData.MediaSerialNumber, cardData.MediaUnicity);
      });

      Promise.all(requests).then(allDetails => {
        console.log('Tutti i dettagli ricevuti:', allDetails);
        this.allDetails = allDetails;

        /* const updatedCSClist = csclist.map((item, index) => ({
          ...item,
          canAddProduct: this.canBuyProductsOnMedia(allDetails[index])
        })); */

        //this.userProfile.tessere.splice(0, this.userProfile.tessere.length, ...updatedCSClist);
        // this.userProfile = [...updatedCSClist];
        // this.$set(this.userProfile, 'tessere', updatedCSClist)
        this.userProfile = {
          ...this.userProfile,
          tessere: csclist
        }
        this.autoselectIfPossible();
        this.loading = false;
      });

      
    })
    .catch(e => {
      this.loading = false;
      console.warn(e);
      this.internalBus.$emit('notify:warning', {
        text: this.dictValue('ListUpdateError') + (e.status === 418 ? '[VAD]' : ''),
        key: this.notifierKey
      });
    });
},
    autoselectIfPossible () {
      if (this.userProfile && this.userProfile.tessere && this.userProfile.tessere.length === 1 && this.userProfile.tessere[0].canAddProduct ) {
        let csc = this.userProfile.tessere[0]
        this.buying = {
          csc
        }
        this.goTo('/products/csc/' + csc.MediaSerialNumber, true)
      }
    }
  },
  mounted () {
    // this.autoselectIfPossible()
    this.updateCSClist()
  }
}
</script>

<style lang="scss">

#app.default .csc-list {
  // display: flex;
  // flex-direction: column;

  & > * {
    margin: 1rem;
    display: flex;
    flex-direction: row;
  }
}

#app.small .csc-list {
  // display: flex;
  // flex-direction: column;
  // flex-wrap: wrap;

  & > * {
    margin-top: 1rem;

    &:nth-child(1) {
      margin-top: 0;
    }
  }
}

</style>
